<template>
  <section v-if="videoUrl" class="videoHeader" ref="videoSection" :class="{'heroHeader__StackedElements': stackedElements}">
    <video :src="videoUrl" poster="/resources/images/video-poster.jpg" data-not-lazy autoplay muted loop playsinline></video>

    <div v-if="titleVisible" class="container">
      <div class="videoHeader__TitleContainer">
        <div v-if="page.lead" class="videoHeader__SuperTitle" v-html="page.lead" />
        <h1 class="videoHeader__Title" v-text="page.title" />
      </div>
    </div>
    
    <div v-if="$slots.default" class="heroHeader__SlotContainer">
      <slot />
    </div>
  </section>
</template>

<script setup>
  const { page } = usePage();
  const props = defineProps({
    titleVisible: {
      type: Boolean,
      default: true,
    },
    notTransparent: {
      type: Boolean,
      default: false,
    },
    stackedElements: {
      type: Boolean,
      default: false,
    },
  })

  useHead({
    link: [
      {
        rel: 'preload',
        as: 'image',
        fetchpriority: 'high',
        href: '/resources/images/video-poster.jpg',
      },
    ],
  });

  const videoSection = ref(null);

  const videoUrl = computed(() => {
    return window?.innerWidth < 768 && page.value?.video_mobile_url ? page.value.video_mobile_url : page.value.video_url
  });

  onMounted(() => {
    if (props.notTransparent) return;
    document.documentElement.classList.add('transparentHeader');
    window.addEventListener('scroll', detectHeaderPosition);
  });

  onBeforeUnmount(() => {
    if (props.notTransparent) return;
    document.documentElement.classList.remove('transparentHeader');
    window.removeEventListener('scroll', detectHeaderPosition);
  });

  function detectHeaderPosition() {
    const { top } = videoSection.value.getBoundingClientRect();
    if (![null, undefined].includes(top)) document.documentElement.classList[(top < 0) ? 'remove' : 'add']('transparentHeader');
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_videoHeader.scss');
</style>